<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer016">
<p class="pictures_logo"><span class="Small-Cap"> </span></p>
<p class="Dedication"><span class="Small-Cap"> </span></p>
<p class="Dedication"><span class="Small-Cap"> </span></p>
<p class="Dedication"><span class="Small-Cap"> </span></p>
<p class="Dedication"><span class="Small-Cap">Also available</span></p>
<p class="Dedication"><span class="Small-Cap"> </span></p>
<p class="body_Body-Centered">More Random Acts o<span class="noBreak">f</span><span class="noBreak"> </span><span class="noBreak">Kindness</span></p>
<p class="body_Body-Centered">Kids’ Random Acts o<span class="noBreak">f</span><span class="noBreak"> </span><span class="noBreak">Kindness</span></p>
<p class="body_Body-Centered">The Practice o<span class="noBreak">f</span><span class="noBreak"> </span><span class="noBreak">Kindness</span></p>
<p class="body_Body-Centered">The Community o<span class="noBreak">f</span><span class="noBreak"> </span><span class="noBreak">Kindness</span></p>
<p class="body_Body-Centered">Practice Random Acts o<span class="noBreak">f</span><span class="noBreak"> </span><span class="noBreak">Kindness</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RandomActsKindness.vue?1ec7536f